<template>
  <div
      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
  >
    <div
        class="bg-white rounded-lg shadow-lg w-3/4 max-w-4xl p-6 overflow-y-auto max-h-screen"
    >
      <h2 class="text-xl font-semibold mb-4">Edit Roles</h2>

      <!-- AG Data Grid for Roles -->
      <ag-grid-vue
          class="ag-theme-balham w-full h-96"
          :rowData="roles"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowDragManaged="true"
          :animateRows="true"
          :components="gridComponents"
          :gridOptions="gridOptions"
          rowSelection="single"
          @grid-ready="onGridReady"
      ></ag-grid-vue>

      <!-- Add Role Button -->
      <button
          @click="addRole"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mt-4"
      >
        Add Role
      </button>

      <!-- Save and Cancel Buttons -->
      <div class="flex justify-end space-x-4 mt-6">
        <button
            @click="cancel"
            class="px-4 py-2 rounded border hover:bg-gray-100"
        >
          Cancel
        </button>
        <button
            @click="save"
            class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue3";
import ColorRenderer from "@/components/common/ColorRenderer.vue";
import ColorSelector from "@/components/common/ColorSelector.vue";
import DeleteButtonRenderer from "@/components/common/DeleteButtonRenderer.vue";

export default {
  name: "RolesEditor",
  components: {
    AgGridVue,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      roles: [], // Local copy of roles
      initialRoles: [],
      gridComponents: {
        ColorRenderer,
        ColorSelector,
        DeleteButtonRenderer
      },
      columnDefs: [
        {headerName: "Role Title", field: "role_title", editable: true, rowDrag: true},
        {
          headerName: "Color",
          field: "color",
          cellRenderer: "ColorRenderer",
          editable: true,
          cellEditor: "ColorSelector",
          width: 96
        },
        {
          headerName: "Leaderboards",
          field: "include_in_leaderboards",
          editable: true,
          width: 112
        },
        {headerName: "Poll Set", field: "poll_set", editable: true},
        {
          headerName: "Actions",
          cellRenderer: "DeleteButtonRenderer",
          cellRendererParams: {
            onClicked(params) {
              params.api.applyTransaction({remove: [{role_title: params.node.id}]});
            }
          }
        },
      ],
      defaultColDef: {
        resizable: true,
        sortable: false,
      },
      gridOptions: {
        getRowId(row) {
          return row.data.role_title;
        }
      },
      gridApi: null
    };
  },
  created() {
    this.roles = this.params.value.map((role) => ({...role, color: '#' + role.color}));
    this.initialRoles = this.roles.map((role) => ({...role}));
  },
  methods: {
    getValue() {
      return this.roles;
    },
    isPopup() {
      return true;
    },
    onGridReady(params) {
      this.gridApi = params.api;
    },
    addRole() {
      this.roles.push({
        color: "#FFFFFF",
        include_in_leaderboards: false,
        poll_set: "",
        role_title: "",
      });
    },
    removeRole(index) {
      this.roles.splice(index, 1);
    },
    save() {
      const reorderedRoles = [];
      this.gridApi.forEachNodeAfterFilterAndSort((node) => {
        reorderedRoles.push(node.data);
      });
      this.roles = reorderedRoles;
      this.params.stopEditing();
    },
    cancel() {
      this.roles = [...this.initialRoles];
      this.params.stopEditing();
    },
  },
};
</script>

<style scoped>
/* Optional custom styles can be added here */
</style>
